export default function ConsistencyReviewPanel({ review, busy, error, pendingSubmit, onContinue, onDismiss }) {
  if (!busy && !error && !review) return null;

  const issues = review?.issues || [];
  return (
    <section className="rounded-lg border border-amber-300 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-950">
      <h3 className="text-sm font-semibold text-amber-900 dark:text-amber-100">Consistency review</h3>
      {busy && <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">Reviewing the full intake for contradictions…</p>}
      {!busy && error && (
        <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">
          The consistency review could not run ({error}). You can still submit this matter.
        </p>
      )}
      {!busy && !error && review?.clean && (
        <p className="mt-1 text-sm text-emerald-800 dark:text-emerald-200">No genuine cross-field contradictions were found.</p>
      )}
      {!busy && !error && issues.length > 0 && (
        <>
          <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">
            Please consider these possible contradictions before submitting. This is an AI-suggested review, not a legal determination.
          </p>
          <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-amber-900 dark:text-amber-100">
            {issues.map((issue, index) => (
              <li key={`${issue.summary}-${index}`}>
                <span className="font-medium">{issue.summary}</span>
                {issue.fields?.length > 0 && <span className="text-amber-800 dark:text-amber-200"> ({issue.fields.join('; ')})</span>}
              </li>
            ))}
          </ul>
        </>
      )}
      {pendingSubmit && !busy && (
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onContinue}
            className="rounded bg-amber-700 px-4 py-2 text-sm font-medium text-white hover:bg-amber-800"
          >
            Continue anyway
          </button>
          <button
            type="button"
            onClick={onDismiss}
            className="rounded border border-amber-400 px-4 py-2 text-sm text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-900"
          >
            Dismiss and continue
          </button>
        </div>
      )}
    </section>
  );
}
